<template>
  <div class="my-work-info-wrap">
    <!-- 编辑 -->
    <div v-if="isEdit" class="edit-wrap">
      <div class="title-wrap">
        <span>我的作业</span>
        <div>
          <button @click="handleCancelEdit" class="cancel-btn">取消</button>
          <button
            @click="submitAnswer"
            :disabled="btnDisabled"
            class="submit-btn"
          >
            完成
          </button>
        </div>
      </div>
      <quill-editor
        ref="questionEditor"
        v-model="content"
        :is-show-audio-toolbar="true"
        :disabled="false"
        :limit-length="1000"
        @show-record-audio="handleShowRecordAudio"
      />
      <!-- 录音  -->
      <audio-record
        v-if="audioRecordVisible"
        class="audio-container"
        @update-audio-url="onUpdateAudioUrl"
        @close="handleCloseAudioRecord"
        ref="audioRecord"
      />
    </div>
    <!-- 未提交 -->
    <button
      v-else-if="[WORK_STATUS.Not_SUBMIT, 0].includes(workInfo.status)"
      class="write-btn"
      @click="handleWriteBtnClick"
      :disabled="workInfo.isTimeOut"
    >
      写作业
    </button>
    <!-- 已提交 -->
    <div v-else class="pending-review">
      <div class="title-wrap">
        <span>我的作业</span>
        <!-- 待批阅 -->
        <div
          v-if="workInfo.status === WORK_STATUS.Not_CORRECTED"
          class="operate-wrap"
        >
          <button
            @click="handleWriteBtnClick"
            class="edit-btn"
            :disabled="workInfo.isTimeOut"
          >
            编辑
          </button>
          <template v-if="workInfo.only_teacher_look !== 1">
            <span class="divider"></span>
            <el-checkbox
              class="only-teacher-look-btn"
              v-model="onlyTeacherLook"
              @change="handleCheckBoxChange"
              >仅老师可见</el-checkbox
            >
          </template>
        </div>
      </div>
      <!-- 作业信息（学生和同学） -->
      <answer-info :isMyAnswer="true" :info="handleMyAnswerInfo" />
    </div>
  </div>
</template>

<script>
import AnswerInfo from "@saas/pages/src/homework-custom/components/AnswerInfo.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { WORK_STATUS } from "@saas/components/src/constants/question";
import {
  answerQuestion,
  onlyTeacherLook,
  submitWork,
} from "@saas/service-api/src/homework/index";
import { AudioRecord, removeOuterHTMLTags } from "@saas/components";
import QuillEditor from "@saas/pages/src/homework-custom/components/QuillEditor.vue";
export default {
  props: {
    workInfo: {
      type: Object,
      default: () => {},
    },
    questionInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      WORK_STATUS,
      onlyTeacherLook: false,
      content: "",
      isEdit: false,
      audioRecordVisible: false,
      btnDisabled: true,
    };
  },
  methods: {
    handleCancelEdit() {
      this.isEdit = false;
    },
    handleWriteBtnClick() {
      this.content = this.handleMyAnswerInfo?.answer || "";
      this.isEdit = true;
      setTimeout(() => {
        this.$refs.questionEditor.scrollToBottomFocus(
          this.handleMyAnswerInfo?.answer
        );
      }, 200);
    },
    handleShowRecordAudio() {
      this.audioRecordVisible = true;
      if (this.$refs?.audioRecord?.showAudioRecord === false) {
        this.$refs?.audioRecord?.requestMediaDevices();
      }
    },
    handleCloseAudioRecord() {
      this.audioRecordVisible = false;
    },
    onUpdateAudioUrl(url) {
      this.$refs.questionEditor.handleAudioContent(url);
    },
    submitAnswer() {
      let val = removeOuterHTMLTags(this.content);
      if (!val) {
        this.$showToast("请填写答案");
        return;
      }
      this.apiAnswerQuestion();
    },
    apiAnswerQuestion() {
      let { id, pid } = this.questionInfo;
      answerQuestion({
        work_id: this.workInfo.id,
        question_pid: pid,
        question_id: id,
        answer: this.content,
      }).then((res) => {
        // 交卷
        if (res.code === 1) {
          this.apiSubmitWork();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiSubmitWork() {
      submitWork({
        work_id: this.workInfo.id,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success("提交成功");
          // 修改状态
          this.$emit("updateWorkInfo");
          this.isEdit = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCheckBoxChange() {
      this.apiOnlyTeacherLook();
    },
    apiOnlyTeacherLook() {
      let params = {
        work_id: this.workInfo.id,
        action: this.onlyTeacherLook ? 1 : 2,
      };
      onlyTeacherLook(params).then((res) => {
        if (res.code === 1) {
          // 修改状态
          this.$emit("updateOnlyTeacherLook", params.action);
          this.$showToast(
            params.action === 1 ? "您的作业仅老师可见" : "取消成功"
          );
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  components: {
    QuillEditor,
    AudioRecord,
    AnswerInfo,
  },
  computed: {
    ...mapGetters(["user"]),
    handleMyAnswerInfo() {
      let { sub_time, status, correct_user_name } = this.workInfo;
      let { answer, teacher_answer, teacher_analysis, score } =
        this.questionInfo?.user_answer || {};
      let { nickname, avatar, user_id } = this.user || {};
      return {
        answer,
        avatar,
        nickname,
        sub_time,
        user_work_id: user_id,
        teacher_answer,
        teacher_analysis,
        score,
        corrected: status === WORK_STATUS.CORRECTED,
        operator_name: correct_user_name,
      };
    },
  },
  watch: {
    workInfo: {
      immediate: true,
      handler(val) {
        this.onlyTeacherLook = val.stu_only_teacher_look === 1;
      },
    },
    content: {
      immediate: true,
      handler(val) {
        let tag = removeOuterHTMLTags(val);
        if (!tag) {
          this.btnDisabled = true;
        } else {
          this.btnDisabled = false;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.my-work-info-wrap {
  .write-btn {
    max-width: 100%;
    width: 480px;
    height: 32px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    margin: 0 auto;
    margin-top: 14px;
  }
}
.audio-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 9;
}
.edit-wrap {
  margin-top: 10px;
  background: #ffffff;
  box-shadow: 0px 2px 16px 0px rgba(102, 116, 107, 0.1);
  border-radius: 16px;
  border: 1px solid #00c89d;
  .title-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;
    color: #0d1400;
    line-height: 22px;
    padding: 12px 14px 0 16px;
    .cancel-btn {
      font-weight: 400;
      font-size: 14px;
      color: #858687;
    }
    .submit-btn {
      font-weight: 400;
      width: 42px;
      height: 24px;
      border-radius: 6px;
      border: 1px solid #00c89d;
      font-size: 14px;
      color: #00c89d;
      line-height: 20px;
      margin-left: 16px;
    }
  }
}
.pending-review {
  margin-top: 12px;
  background: #f7f8fa;
  border-radius: 16px;
  border: 1px solid #f2f3f5;
  .title-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;
    color: #0d1400;
    line-height: 22px;
    padding: 12px 18px 0 16px;
  }
  .edit-btn {
    font-weight: 400;
    font-size: 14px;
    color: #747573;
    line-height: 20px;
  }
  .operate-wrap {
    display: flex;
    align-items: center;
  }
  .divider {
    display: flex;
    width: 1px;
    height: 13px;
    background: #c9cdd4;
    margin: 0 12px;
  }
  ::v-deep .only-teacher-look-btn {
    .el-checkbox__label {
      padding: 0;
      font-weight: 400;
      font-size: 14px;
      color: #747573;
      line-height: 20px;
    }
    .el-checkbox__inner {
      margin-right: 5px;
      border-radius: 50%;
      margin-bottom: 2px;
    }
  }
}
.answer-info {
  padding: 0 16px;
  .top-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .user-info {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 6px;
    }
    .name {
      font-weight: 400;
      font-size: 14px;
      color: #0d1400;
      line-height: 20px;
      margin-bottom: 2px;
    }
    .time {
      font-weight: 400;
      font-size: 11px;
      color: #747573;
      line-height: 16px;
    }
  }
  .more-btn {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    border: 1px solid #e5e6eb;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
<style lang="scss">
.homework-complaint-popover {
  min-width: auto;
  height: 36px;
  background: #ffffff;
  box-shadow: 0px 2px 16px 0px rgba(102, 116, 107, 0.1);
  border-radius: 8px;
  border: 1px solid #e5e6e8;
  color: #0d1400;
  padding: 8px 0 0 16px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  margin-top: 0 !important;
}
</style>
